import Vue from 'vue'
import Router from 'vue-router'

import BGG from './components/screen/BGG'
import bggSearch from './components/screen/bgg/Search'

import Profile from './components/screen/Profile'
import profileSync from './components/screen/profile/Sync'
import profileCollection from './components/screen/profile/Collection'
import profileActivity from './components/screen/profile/Activity'
import profileUsers from './components/screen/profile/Users'
import profilePlays from './components/screen/profile/Plays'
import profileRatings from './components/screen/profile/Ratings'

import profileInsightsPlays from './components/screen/profile/insights/Plays'
import profileInsightsRatings from './components/screen/profile/insights/Ratings'
import profileInsightsCollection from './components/screen/profile/insights/Collection'
import profileInsightsShelf from './components/screen/profile/insights/Shelf'
import profileInsightsSize from './components/screen/profile/insights/Size'
import profileInsightsMembers from './components/screen/profile/insights/Members'
import profileInsightsHindex from './components/screen/profile/insights/Hindex'
import profileInsightsRecords from './components/screen/profile/insights/Records'
import profileInsightsWorth from './components/screen/profile/insights/Worth'
import profileInsightsPlayers from './components/screen/profile/insights/Players'
import profileInsightsPlayer from './components/screen/profile/insights/Player'
import profileInsightsGames from './components/screen/profile/insights/Games'
import profileInsightsGame from './components/screen/profile/insights/Game'

import profileLists from './components/screen/profile/Lists'
import profileList from './components/screen/profile/List'

import profileTools from './components/screen/profile/Tools'
import profileToolPlayGrid from './components/screen/profile/tool/PlayGrid'
import profileToolHeatmap from './components/screen/profile/tool/Heatmap'
import profileToolWordCloud from './components/screen/profile/tool/WordCloud'

import Home from './components/screen/Home'
import Verify from './components/screen/Verify'
import Reset from './components/screen/Reset'
import Notfound from './components/screen/404'
import ErrorEncounted from './components/screen/Error'

import sessionPatreon from './components/screen/session/Patreon'
import sessionSettings from './components/screen/session/Settings'
import sessionSyncs from './components/screen/session/Syncs'

import sessionPatreonAccess from './components/screen/session/PatreonAccess'
import sessionPatreonBoosts from './components/screen/session/PatreonBoosts'
import sessionPatreonSubdomains from './components/screen/session/PatreonSubdomains'
import sessionPatreonExternaldomains from './components/screen/session/PatreonExternaldomains'
import sessionPatreonSyncs from './components/screen/session/PatreonSyncs'

import communityVoting from './components/screen/community/Voting'
import communityPatreon from './components/screen/community/Patreon'
import communityAccess from './components/screen/community/Access'

import logoutGuard from './router/logout.js'

import qs from 'qs'

Vue.use(Router)

var routes = []

if (process.env.VUE_APP_TYPE === 'subdomain' || process.env.VUE_APP_TYPE === 'externaldomain') {

	routes = [
		{
			path: '/404',
			name: '404',
			component: Notfound,
			meta: {
				title: 'Page not found',
				isStandalone: true
			}
		},
		{
			path: '/error',
			name: 'Error',
			component: ErrorEncounted,
			meta: {
				title: 'Error',
				isStandalone: true
			}
		},
		{
			path: '/logout',
			name: 'Logout',
			component: Home,
			meta: {
				title: 'Logout',
				requireUser: true,
				isStandalone: true
			},
			beforeEnter: logoutGuard
		},
		{
			path: '/verify/:key',
			name: 'Verify',
			component: Verify,
			meta: {
				title: 'Verify',
				requireGuest: true,
				isStandalone: true
			}
		},
		{
			path: '/reset/:key',
			name: 'Reset',
			component: Reset,
			meta: {
				title: 'Reset',
				requireGuest: true,
				isStandalone: true
			}
		},
		{
			path: '/my',
			name: 'Session',
			component: sessionSettings,
			meta: {
				title: 'Settings',
				mobiletitle: 'Settings',
				requireUser: true,
				isSession: true
			}
		},
		{
			path: '/my/settings',
			name: 'SessionSettings',
			component: sessionSettings,
			meta: {
				title: 'Settings',
				mobiletitle: 'Settings',
				requireUser: true,
				isSession: true
			}
		},
		{
			path: '/my/syncs',
			name: 'SessionSyncs',
			component: sessionSyncs,
			meta: {
				title: 'Syncs',
				mobiletitle: 'Syncs',
				requireUser: true,
				isSession: true,
				nofilter: true
			}
		},
		{
			path: '/my/patreon',
			name: 'SessionPatreon',
			component: sessionPatreon,
			meta: {
				title: 'Patreon',
				mobiletitle: 'Patreon',
				requireUser: true,
				isSession: true
			}
		},
		{
			path: '/my/patreon/early-access',
			name: 'SessionPatreonAccess',
			component: sessionPatreonAccess,
			meta: {
				title: 'Patreon - Early Access',
				mobiletitle: 'Early Access',
				mobilesubtitle: 'Patreon',
				requireUser: true,
				isSession: true,
				nofilter: true
			}
		},
		{
			path: '/my/patreon/speed-boosts',
			name: 'SessionPatreonBoosts',
			component: sessionPatreonBoosts,
			meta: {
				title: 'Patreon - Speed Boosts',
				mobiletitle: 'Speed Boosts',
				mobilesubtitle: 'Patreon',
				requireUser: true,
				isSession: true,
				nofilter: true
			}
		},
		{
			path: '/my/patreon/subdomains',
			name: 'SessionPatreonSubdomains',
			component: sessionPatreonSubdomains,
			meta: {
				title: 'Patreon - Subdomains',
				mobiletitle: 'Subdomains',
				mobilesubtitle: 'Patreon',
				requireUser: true,
				isSession: true,
				nofilter: true
			}
		},
		{
			path: '/my/patreon/externaldomains',
			name: 'SessionPatreonExternaldomains',
			component: sessionPatreonExternaldomains,
			meta: {
				title: 'Patreon - External Domains',
				mobiletitle: 'External Domains',
				mobilesubtitle: 'Patreon',
				requireUser: true,
				isSession: true,
				nofilter: true
			}
		},
		{
			path: '/my/patreon/feature-voting',
			name: 'SessionPatreonVoting',
			component: communityVoting,
			meta: {
				title: 'Patreon - Feature Voting',
				mobiletitle: 'Feature Voting',
				mobilesubtitle: 'Patreon',
				requireUser: true,
				isSession: true,
				nofilter: true
			}
		},
		{
			path: '/my/patreon/group-syncs',
			name: 'SessionPatreonSyncs',
			component: sessionPatreonSyncs,
			meta: {
				title: 'Patreon - Group Syncs',
				mobiletitle: 'Group Syncs',
				mobilesubtitle: 'Patreon',
				requireUser: true,
				isSession: true,
				nofilter: true
			}
		},
		{
			path: '/community/feature-voting',
			name: 'CommunityVoting',
			component: communityVoting,
			meta: {
				isCommunity: true,
				title: 'Feature Voting'
			}
		},
		{
			path: '/community/early-access',
			name: 'CommunityAccess',
			component: communityAccess,
			meta: {
				isCommunity: true,
				title: 'Early Access'
			}
		},
		{
			path: '/community',
			name: 'Community',
			component: communityPatreon,
			meta: {
				isCommunity: true,
				title: 'Patreon'
			}
		},
		{
			path: '/community/patreon',
			name: 'CommunityPatreon',
			component: communityPatreon,
			meta: {
				isCommunity: true,
				title: 'Patreon'
			}
		},
		{
			path: '/',
			component: Profile,
			children: [
				{
					path: '',
					name: 'Default',
					component: profileCollection,
					meta: {
						title: 'Collection',
						mobiletitle: 'Collection',
						search: {
							store: 'filter/collection/text',
							placeholder: 'Search collection...'
						},
						hasSearch: true,
						hasViews: 'collection',
						hasActions: true,
						isProfile: true,
						isListing: function() {

							return this.$store.getters['filter/config/collection/layout'] !== this.$CONSTANTS.LAYOUT.COLLECTION.GRID
							
						}
					}
				},
				{
					path: 'sync',
					name: 'Sync',
					component: profileSync,
					meta: {
						title: 'Sync',
						isStandalone: true,
						isProfile: true
					}
				},
				{
					path: 'collection',
					name: 'Collection',
					component: profileCollection,
					meta: {
						title: 'Collection',
						mobiletitle: 'Collection',
						search: {
							store: 'filter/collection/text',
							placeholder: 'Search collection...'
						},
						hasSearch: true,
						hasViews: 'collection',
						hasActions: true,
						isProfile: true,
						isListing: function() {

							return this.$store.getters['filter/config/collection/layout'] !== this.$CONSTANTS.LAYOUT.COLLECTION.GRID
							
						}
					}
				},
				{
					path: 'activity',
					name: 'Activity',
					component: profileActivity,
					meta: {
						title: 'Activity',
						mobiletitle: 'Activity',
						isProfile: true,
						isListing: true
					}
				},
				{
					path: 'users',
					name: 'Users',
					component: profileUsers,
					meta: {
						title: 'Users',
						mobiletitle: 'Users',
						isProfile: true,
						isListing: true
					}
				},
				{
					path: 'ratings',
					name: 'Ratings',
					component: profileRatings,
					meta: {
						title: 'Ratings',
						mobiletitle: 'Ratings',
						hasActions: true,
						hasSearch: true,
						search: {
							store: 'filter/ratings/text',
							placeholder: 'Search ratings...'
						},
						hasViews: 'ratings',
						isProfile: true,
						isListing: function() {

							return this.$store.getters['filter/config/ratings/layout'] !== this.$CONSTANTS.LAYOUT.RATINGS.CARDS
							
						}
					}
				},
				{
					path: 'lists',
					name: 'Lists',
					component: profileLists,
					meta: {
						title: 'Lists',
						mobiletitle: 'Lists',
						isProfile: true
					}
				},
				{
					path: 'lists/:list/:edition',
					name: 'Edition',
					component: profileList,
					meta: {
						title: 'List',
						mobiletitle: function() {

							return this.$store.getters['page/list/list'].name

						},
						mobilesubtitle: 'List',
						isProfile: true,
						isListing: true
					}
				},
				{
					path: 'lists/:list',
					name: 'List',
					component: profileList,
					meta: {
						title: 'List',
						mobiletitle: function() {

							return this.$store.getters['page/list/list'].name

						},
						mobilesubtitle: 'List',
						isProfile: true,
						isListing: true
					}
				},
				{
					path: 'plays',
					name: 'Plays',
					component: profilePlays,
					meta: {
						title: 'Plays',
						mobiletitle: 'Plays',
						search: {
							store: 'filter/plays/text',
							placeholder: 'Search plays...'
						},
						hasViews: function() {

							return (this.$store.getters['filter/plays/play/group']) ? 'gameplays' : 'plays'

						},
						hasSearch: true,
						isProfile: true,
						hasActions: true,
						isListing: function() {

							return this.$store.getters['filter/config/plays/layout'] !== this.$CONSTANTS.LAYOUT.PLAYS.CARDS
							
						}
					}
				},
				{
					path: 'tools',
					name: 'Tools',
					component: profileTools,
					meta: {
						title: 'Tools',
						mobiletitle: 'Tools',
						nofilter: true,
						isProfile: true
					}
				},
				{
					path: 'tools/play-grid',
					name: 'ToolsPlayGrid',
					component: profileToolPlayGrid,
					meta: {
						title: 'Play Grid | Tools',
						mobiletitle: 'Play Grid',
						mobilesubtitle: 'Tools',
						isProfile: true
					}
				},
				{
					path: 'tools/wordcloud',
					name: 'ToolsWordCloud',
					component: profileToolWordCloud,
					meta: {
						title: 'Word Cloud | Tools',
						mobiletitle: 'Word Cloud',
						mobilesubtitle: 'Tools',
						isProfile: true
					}
				},
				{
					path: 'tools/heatmap',
					name: 'ToolsHeatmap',
					component: profileToolHeatmap,
					meta: {
						title: 'Heatmap | Tools',
						mobiletitle: 'Heatmap',
						mobilesubtitle: 'Tools',
						isProfile: true
					}
				},
				{
					path: 'insights',
					name: 'Insights',
					component: profileInsightsCollection,
					meta: {
						title: 'Collection | Insights',
						mobiletitle: 'Collection',
						mobilesubtitle: 'Insights',
						section: 'collection',
						subtitle: 'Collection',
						nofilter: true,
						isProfile: true
					}
				},
				{
					path: 'insights/collection/shelf',
					name: 'InsightsShelf',
					component: profileInsightsShelf,
					meta: {
						title: function() {
						
							return 'Shelf of ' + ((this.$store.getters['session/config'].lists.unplayed.type === 'shame') ? 'Shame' : 'Opportunity') + ' | Insights'

						},
						mobiletitle: function() {
						
							return 'Shelf of ' + ((this.$store.getters['session/config'].lists.unplayed.type === 'shame') ? 'Shame' : 'Opportunity')

						},
						mobilesubtitle: 'Collection Insights',
						section: 'shelf',
						parenttitle: 'Collection',
						subtitle: 'Shelf of Shame',
						isProfile: true
					}
				},
				{
					path: 'insights/collection/worth',
					name: 'InsightsWorth',
					component: profileInsightsWorth,
					meta: {
						title: 'Collection Worth | Insights',
						mobiletitle: 'Worth',
						mobilesubtitle: 'Collection Insights',
						section: 'worth',
						parenttitle: 'Collection',
						subtitle: 'Worth',
						isProfile: true
					}
				},
				{
					path: 'insights/collection/size',
					name: 'InsightsSize',
					component: profileInsightsSize,
					meta: {
						title: 'Collection Size | Insights',
						mobiletitle: 'Size',
						mobilesubtitle: 'Collection Insights',
						section: 'size',
						parenttitle: 'Collection',
						subtitle: 'Size',
						nofilter: true,
						isProfile: true
					}
				},
				{
					path: 'insights/plays',
					name: 'InsightsPlays',
					component: profileInsightsPlays,
					meta: {
						title: 'Plays | Insights',
						mobiletitle: 'Plays',
						mobilesubtitle: 'Insights',
						section: 'plays',
						subtitle: 'Plays',
						isProfile: true
					}
				},
				{
					path: 'insights/collection',
					name: 'InsightsCollection',
					component: profileInsightsCollection,
					meta: {
						title: 'Collection | Insights',
						mobiletitle: 'Collection',
						mobilesubtitle: 'Insights',
						section: 'collection',
						subtitle: 'Collection',
						nofilter: true,
						isProfile: true
					}
				},
				{
					path: 'insights/ratings',
					name: 'InsightsRatings',
					component: profileInsightsRatings,
					meta: {
						title: 'Ratings | Insights',
						mobiletitle: 'Ratings',
						mobilesubtitle: 'Insights',
						section: 'ratings',
						subtitle: 'Ratings',
						nofilter: true,
						isProfile: true
					}
				},
				{
					path: 'insights/members',
					name: 'InsightsMembers',
					component: profileInsightsMembers,
					meta: {
						title: 'Members | Insights',
						mobiletitle: 'Members',
						mobilesubtitle: 'Insights',
						section: 'members',
						subtitle: 'Members',
						nofilter: true,
						isProfile: true
					}
				},
				{
					path: 'insights/plays/players',
					name: 'InsightsPlayers',
					component: profileInsightsPlayers,
					meta: {
						title: 'Friends & Foes | Plays | Insights',
						mobiletitle: 'Friends & Foes',
						mobilesubtitle: 'Play Insights',
						section: 'players',
						parenttitle: 'Plays',
						subtitle: 'Friends & Foes',
						early: 'friends_and_foes',
						isProfile: true
					}
				},
				{
					path: 'insights/plays/players/:player',
					name: 'InsightsPlayer',
					component: profileInsightsPlayer,
					meta: {
						title: 'Friends & Foes | Plays | Insights',
						mobiletitle: 'Friend & Foes',
						mobilesubtitle: 'Play Insights',
						section: 'player',
						parenttitle: 'Plays',
						subtitle: 'Friends & Foes',
						early: 'friends_and_foes',
						isProfile: true
					}
				},
				{
					path: 'insights/plays/h-index',
					name: 'InsightsHindex',
					component: profileInsightsHindex,
					meta: {
						title: 'Play H-index | Insights',
						mobiletitle: 'H-index',
						mobilesubtitle: 'Play Insights',
						section: 'hindex',
						parenttitle: 'Plays',
						subtitle: 'H-index',
						isProfile: true
					}
				},
				{
					path: 'insights/plays/h-index/:index',
					name: 'InsightsHindexIndex',
					component: profileInsightsHindex,
					meta: {
						title: 'Play H-index | Insights',
						mobiletitle: 'H-index',
						mobilesubtitle: 'Play Insights',
						section: 'hindex',
						parenttitle: 'Plays',
						subtitle: 'H-index',
						isProfile: true
					}
				},
				{
					path: 'insights/plays/streaks-and-records',
					name: 'InsightsRecords',
					component: profileInsightsRecords,
					meta: {
						title: 'Play Streaks & Records | Insights',
						mobiletitle: 'Streaks & Records',
						mobilesubtitle: 'Play Insights',
						section: 'records',
						parenttitle: 'Plays',
						subtitle: 'Streaks & Records',
						isProfile: true
					}
				},
				{
					path: 'insights/games',
					name: 'InsightsGames',
					component: profileInsightsGames,
					meta: {
						title: 'Games | Insights',
						mobiletitle: 'Games',
						mobilesubtitle: 'Insights',
						section: 'games',
						subtitle: 'Games',
						nofilter: true,
						early: 'games_insights',
						isProfile: true
					}
				},
				{
					path: 'insights/games/:game',
					name: 'InsightsGame',
					component: profileInsightsGame,
					meta: {
						title: 'Game | Insights',
						mobiletitle: function() {

							var game = this.$store.getters['page/insights/game/game']
							return (game && game.name) ? game.name : 'Game'

						},
						mobilesubtitle: 'Game Insights',
						section: 'game',
						parenttitle: 'Games',
						subtitle: 'Game',
						nofilter: true,
						early: 'games_insights',
						isProfile: true
					}
				}
			],
			meta: {
				requireVerify: true,
				isProfile: true
			}
		}
	]

} else {

	routes = [
		{
			path: '/',
			name: 'Home',
			component: Home,
			meta: {
				title: 'Home',
				nofilter: true,
				isHome: true,
				isCommunity: true
			}
		},
		{
			path: '/404',
			name: '404',
			component: Notfound,
			meta: {
				title: 'Page not found',
				isStandalone: true
			}
		},
		{
			path: '/error',
			name: 'Error',
			component: ErrorEncounted,
			meta: {
				title: 'Error',
				isStandalone: true
			}
		},
		{
			path: '/logout',
			name: 'Logout',
			component: Home,
			meta: {
				title: 'Logout',
				requireUser: true,
				isStandalone: true
			},
			beforeEnter: logoutGuard
		},
		{
			path: '/verify/:key',
			name: 'Verify',
			component: Verify,
			meta: {
				title: 'Verify',
				requireGuest: true,
				isStandalone: true
			}
		},
		{
			path: '/reset/:key',
			name: 'Reset',
			component: Reset,
			meta: {
				title: 'Reset',
				requireGuest: true,
				isStandalone: true
			}
		},
		{
			path: '/my',
			name: 'Session',
			component: sessionSettings,
			meta: {
				title: 'Settings',
				mobiletitle: 'Settings',
				requireUser: true,
				isSession: true
			}
		},
		{
			path: '/my/settings',
			name: 'SessionSettings',
			component: sessionSettings,
			meta: {
				title: 'Settings',
				mobiletitle: 'Settings',
				requireUser: true,
				isSession: true
			}
		},
		{
			path: '/my/syncs',
			name: 'SessionSyncs',
			component: sessionSyncs,
			meta: {
				title: 'Syncs',
				mobiletitle: 'Syncs',
				requireUser: true,
				isSession: true
			}
		},
		{
			path: '/my/patreon',
			name: 'SessionPatreon',
			component: sessionPatreon,
			meta: {
				title: 'Patreon',
				mobiletitle: 'Patreon',
				requireUser: true,
				nofilter: true,
				isSession: true
			}
		},
		{
			path: '/my/patreon/early-access',
			name: 'SessionPatreonAccess',
			component: sessionPatreonAccess,
			meta: {
				title: 'Patreon - Early Access',
				mobiletitle: 'Early Access',
				mobilesubtitle: 'Patreon',
				requireUser: true,
				isSession: true,
				nofilter: true
			}
		},
		{
			path: '/my/patreon/speed-boosts',
			name: 'SessionPatreonBoosts',
			component: sessionPatreonBoosts,
			meta: {
				title: 'Patreon - Speed Boosts',
				mobiletitle: 'Speed Boosts',
				mobilesubtitle: 'Patreon',
				requireUser: true,
				isSession: true,
				nofilter: true
			}
		},
		{
			path: '/my/patreon/subdomains',
			name: 'SessionPatreonSubdomains',
			component: sessionPatreonSubdomains,
			meta: {
				title: 'Patreon - Subdomains',
				mobiletitle: 'Subdomains',
				mobilesubtitle: 'Patreon',
				requireUser: true,
				isSession: true,
				nofilter: true
			}
		},
		{
			path: '/my/patreon/externaldomains',
			name: 'SessionPatreonExternaldomains',
			component: sessionPatreonExternaldomains,
			meta: {
				title: 'Patreon - External Domains',
				mobiletitle: 'External Domains',
				mobilesubtitle: 'Patreon',
				requireUser: true,
				isSession: true
			}
		},
		{
			path: '/my/patreon/feature-voting',
			name: 'SessionPatreonVoting',
			component: communityVoting,
			meta: {
				title: 'Patreon - Feature Voting',
				mobiletitle: 'Feature Voting',
				mobilesubtitle: 'Patreon',
				requireUser: true,
				isSession: true,
				nofilter: true
			}
		},
		{
			path: '/my/patreon/group-syncs',
			name: 'SessionPatreonSyncs',
			component: sessionPatreonSyncs,
			meta: {
				title: 'Patreon - Group Syncs',
				mobiletitle: 'Group Syncs',
				mobilesubtitle: 'Patreon',
				requireUser: true,
				isSession: true,
				nofilter: true
			}
		},
		{
			path: '/community/feature-voting',
			name: 'CommunityVoting',
			component: communityVoting,
			meta: {
				isCommunity: true,
				mobiletitle: 'Feature Voting',
				nofilter: true,
				title: 'Feature Voting'
			}
		},
		{
			path: '/community/early-access',
			name: 'CommunityAccess',
			component: communityAccess,
			meta: {
				isCommunity: true,
				mobiletitle: 'Early Access',
				nofilter: true,
				title: 'Early Access'
			}
		},
		{
			path: '/community',
			name: 'Community',
			component: communityPatreon,
			meta: {
				isCommunity: true,
				title: 'Patreon'
			}
		},
		{
			path: '/community/patreon',
			name: 'CommunityPatreon',
			component: communityPatreon,
			meta: {
				isCommunity: true,
				nofilter: true,
				mobiletitle: 'Patreon',
				title: 'Patreon'
			}
		},
		{
			path: '/bgg',
			component: BGG,
			children: [
				{
					path: '',
					name: 'BGG',
					component: bggSearch,
					meta: {
						title: 'Board Game Geek',
						isBGG: true
					}
				},
				{
					path: 'search',
					name: 'bggSearch',
					component: bggSearch,
					meta: {
						title: 'Board Game Geek',
						isBGG: true
					}
				}
			],
			meta: {
				isBGG: true
			}
		},
		{
			path: '/:type/:name',
			component: Profile,
			children: [
				{
					path: '',
					name: 'Default',
					component: profileCollection,
					meta: {
						title: 'Collection',
						mobiletitle: 'Collection',
						search: {
							store: 'filter/collection/text',
							placeholder: 'Search collection...'
						},
						hasSearch: true,
						hasViews: 'collection',
						isProfile: true,
						hasActions: true,
						isListing: true,
						hasColumns: function() {

							return this.$store.getters['filter/config/collection/layout'] !== this.$CONSTANTS.LAYOUT.COLLECTION.GRID
							
						}
					}
				},
				{
					path: 'sync',
					name: 'Sync',
					component: profileSync,
					meta: {
						title: 'Sync',
						isStandalone: true,
						isProfile: true
					}
				},
				{
					path: 'collection',
					name: 'Collection',
					component: profileCollection,
					meta: {
						title: 'Collection',
						mobiletitle: 'Collection',
						search: {
							store: 'filter/collection/text',
							placeholder: 'Search collection...'
						},
						hasSearch: true,
						hasViews: 'collection',
						isProfile: true,
						hasActions: true,
						isListing: true,
						hasColumns: function() {

							return this.$store.getters['filter/config/collection/layout'] !== this.$CONSTANTS.LAYOUT.COLLECTION.GRID
							
						}
					}
				},
				{
					path: 'activity',
					name: 'Activity',
					component: profileActivity,
					meta: {
						title: 'Activity',
						mobiletitle: 'Activity',
						isProfile: true
					}
				},
				{
					path: 'users',
					name: 'Users',
					component: profileUsers,
					meta: {
						title: 'Users',
						mobiletitle: 'Users',
						isProfile: true,
						isListing: true
					}
				},
				{
					path: 'ratings',
					name: 'Ratings',
					component: profileRatings,
					meta: {
						title: 'Ratings',
						mobiletitle: 'Ratings',
						search: {
							store: 'filter/ratings/text',
							placeholder: 'Search ratings...'
						},
						hasSearch: true,
						hasViews: 'ratings',
						isProfile: true,
						hasActions: true,
						isListing: true,
						hasColumns: function() {

							return this.$store.getters['filter/config/ratings/layout'] !== this.$CONSTANTS.LAYOUT.RATINGS.CARDS
							
						}
					}
				},
				{
					path: 'lists',
					name: 'Lists',
					component: profileLists,
					meta: {
						title: 'Lists',
						mobiletitle: 'Lists',
						isProfile: true
					}
				},
				{
					path: 'lists/:list/:edition',
					name: 'Edition',
					component: profileList,
					meta: {
						title: 'List',
						mobiletitle: function() {

							return this.$store.getters['page/list/list'].name

						},
						mobilesubtitle: 'Lists',
						isProfile: true,
						isListing: true
					}
				},
				{
					path: 'lists/:list',
					name: 'List',
					component: profileList,
					meta: {
						title: 'List',
						mobiletitle: function() {

							return this.$store.getters['page/list/list'].name

						},
						mobilesubtitle: 'Lists',
						isProfile: true,
						isListing: true
					}
				},
				{
					path: 'plays',
					name: 'Plays',
					component: profilePlays,
					meta: {
						title: 'Plays',
						mobiletitle: 'Plays',
						search: {
							store: 'filter/plays/text',
							placeholder: 'Search plays...'
						},
						hasSearch: true,
						hasViews: function() {

							return (this.$store.getters['filter/plays/play/group']) ? 'gameplays' : 'plays'

						},
						hasActions: true,
						isProfile: true,
						isListing: true,
						hasColumns: function() {

							return this.$store.getters['filter/config/plays/layout'] !== this.$CONSTANTS.LAYOUT.PLAYS.CARDS
							
						}
					}
				},
				{
					path: 'tools',
					name: 'Tools',
					component: profileTools,
					meta: {
						title: 'Tools',
						mobiletitle: 'Tools',
						nofilter: true,
						isProfile: true
					}
				},
				{
					path: 'tools/play-grid',
					name: 'ToolsPlayGrid',
					component: profileToolPlayGrid,
					meta: {
						title: 'Play Grid | Tools',
						mobiletitle: 'Play Grid',
						mobilesubtitle: 'Tools',
						isProfile: true
					}
				},
				{
					path: 'tools/wordcloud',
					name: 'ToolsWordCloud',
					component: profileToolWordCloud,
					meta: {
						title: 'Word Cloud | Tools',
						mobiletitle: 'Word Cloud',
						mobilesubtitle: 'Tools',
						isProfile: true
					}
				},
				{
					path: 'tools/heatmap',
					name: 'ToolsHeatmap',
					component: profileToolHeatmap,
					meta: {
						title: 'Heatmap | Tools',
						mobiletitle: 'Heatmap',
						mobilesubtitle: 'Tools',
						isProfile: true
					}
				},
				{
					path: 'insights',
					name: 'Insights',
					component: profileInsightsCollection,
					meta: {
						title: 'Collection | Insights',
						mobiletitle: 'Collection',
						mobilesubtitle: 'Insights',
						section: 'collection',
						subtitle: 'Collection',
						nofilter: true,
						isProfile: true
					}
				},
				{
					path: 'insights/collection/shelf',
					name: 'InsightsShelf',
					component: profileInsightsShelf,
					meta: {
						title: function() {
						
							return 'Shelf of ' + ((this.$store.getters['session/config'].lists.unplayed.type === 'shame') ? 'Shame' : 'Opportunity') + ' | Insights'

						},
						mobiletitle: function() {
						
							return 'Shelf of ' + ((this.$store.getters['session/config'].lists.unplayed.type === 'shame') ? 'Shame' : 'Opportunity')

						},
						mobilesubtitle: 'Collection Insights',
						section: 'shelf',
						parenttitle: 'Collection',
						subtitle: 'Shelf of Shame',
						isProfile: true
					}
				},
				{
					path: 'insights/collection/worth',
					name: 'InsightsWorth',
					component: profileInsightsWorth,
					meta: {
						title: 'Collection Worth | Insights',
						mobiletitle: 'Worth',
						mobilesubtitle: 'Collection Insights',
						section: 'worth',
						parenttitle: 'Collection',
						subtitle: 'Worth',
						isProfile: true
					}
				},
				{
					path: 'insights/collection/size',
					name: 'InsightsSize',
					component: profileInsightsSize,
					meta: {
						title: 'Collection Size | Insights',
						mobiletitle: 'Size',
						mobilesubtitle: 'Collection Insights',
						section: 'size',
						parenttitle: 'Collection',
						subtitle: 'Size',
						nofilter: true,
						isProfile: true
					}
				},
				{
					path: 'insights/plays',
					name: 'InsightsPlays',
					component: profileInsightsPlays,
					meta: {
						title: 'Plays | Insights',
						mobiletitle: 'Plays',
						mobilesubtitle: 'Insights',
						section: 'plays',
						subtitle: 'Plays',
						isProfile: true
					}
				},
				{
					path: 'insights/plays/players',
					name: 'InsightsPlayers',
					component: profileInsightsPlayers,
					meta: {
						title: 'Friends & Foes | Plays | Insights',
						mobiletitle: 'Friends & Foes',
						mobilesubtitle: 'Play Insights',
						section: 'players',
						parenttitle: 'Plays',
						subtitle: 'Friends & Foes',
						early: 'friends_and_foes',
						isProfile: true
					}
				},
				{
					path: 'insights/plays/players/:player',
					name: 'InsightsPlayer',
					component: profileInsightsPlayer,
					meta: {
						title: 'Friends & Foes | Plays | Insights',
						mobiletitle: 'Friends & Foes',
						mobilesubtitle: 'Play Insights',
						section: 'player',
						parenttitle: 'Plays',
						subtitle: 'Friends & Foes',
						early: 'friends_and_foes',
						isProfile: true
					}
				},
				{
					path: 'insights/collection',
					name: 'InsightsCollection',
					component: profileInsightsCollection,
					meta: {
						title: 'Collection | Insights',
						mobiletitle: 'Collection',
						mobilesubtitle: 'Insights',
						section: 'collection',
						subtitle: 'Collection',
						nofilter: true,
						isProfile: true
					}
				},
				{
					path: 'insights/ratings',
					name: 'InsightsRatings',
					component: profileInsightsRatings,
					meta: {
						title: 'Ratings | Insights',
						mobiletitle: 'Ratings',
						mobilesubtitle: 'Insights',
						section: 'ratings',
						subtitle: 'Ratings',
						nofilter: true,
						isProfile: true
					}
				},
				{
					path: 'insights/members',
					name: 'InsightsMembers',
					component: profileInsightsMembers,
					meta: {
						title: 'Members | Insights',
						mobiletitle: 'Members',
						mobilesubtitle: 'Insights',
						section: 'members',
						subtitle: 'Members',
						nofilter: true,
						isProfile: true
					}
				},
				{
					path: 'insights/plays/h-index',
					name: 'InsightsHindex',
					component: profileInsightsHindex,
					meta: {
						title: 'Play H-index | Insights',
						mobiletitle: 'H-index',
						mobilesubtitle: 'Play Insights',
						section: 'hindex',
						parenttitle: 'Plays',
						subtitle: 'H-index',
						isProfile: true
					}
				},
				{
					path: 'insights/plays/h-index/:index',
					name: 'InsightsHindexIndex',
					component: profileInsightsHindex,
					meta: {
						title: 'Play H-index | Insights',
						mobiletitle: 'H-index',
						mobilesubtitle: 'Play Insights',
						section: 'hindex',
						parenttitle: 'Plays',
						subtitle: 'H-index',
						isProfile: true
					}
				},
				{
					path: 'insights/plays/streaks-and-records',
					name: 'InsightsRecords',
					component: profileInsightsRecords,
					meta: {
						title: 'Play Streaks & Records | Insights',
						mobiletitle: 'Streaks & Records',
						mobilesubtitle: 'Play Insights',
						section: 'records',
						parenttitle: 'Plays',
						subtitle: 'Streaks & Records',
						isProfile: true
					}
				},
				{
					path: 'insights/games',
					name: 'InsightsGames',
					component: profileInsightsGames,
					meta: {
						title: 'Games | Insights',
						mobiletitle: 'Games',
						mobilesubtitle: 'Insights',
						section: 'games',
						subtitle: 'Games',
						nofilter: true,
						early: 'games_insights',
						isProfile: true
					}
				},
				{
					path: 'insights/games/:game',
					name: 'InsightsGame',
					component: profileInsightsGame,
					meta: {
						title: 'Game | Insights',
						mobiletitle: function() {

							var game = this.$store.getters['page/insights/game/game']
							return (game && game.name) ? game.name : 'Game'

						},
						mobilesubtitle: 'Game Insights',
						section: 'game',
						parenttitle: 'Games',
						subtitle: 'Game',
						nofilter: true,
						early: 'games_insights',
						isProfile: true
					}
				}
			],
			meta: {
				requireVerify: true,
				isProfile: true
			}
		}
	]

}

export default new Router({
	mode: 'history',
	stringifyQuery: function(query) {
		let result = qs.stringify(query, { format: 'RFC1738', arrayFormat: true })
		result = result.replace(/%2C/g, ',')
		result = result.replace(/%2B/g, '+')
		result = result.replace(/%5B/g, '[')
		result = result.replace(/%5D/g, ']')
		result = result.replace(/%3B/g, ';')
		result = result.replace(/%7B/g, '{')
		result = result.replace(/%7D/g, '}')
		result = result.replace(/%21/g, '!')
		return result ? ('?' + result) : ''
	},
	routes: routes
})
